import { useState, useCallback, createContext, useContext, useLayoutEffect } from 'react'

function getCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return m ? decodeURIComponent(m[1]) : null
}
function setCookie(name, val) {
  document.cookie = name + '=' + encodeURIComponent(val) + ';path=/;max-age=31536000'
}

const ThemeContext = createContext({ dark: false, toggleTheme: () => {}, setDark: () => {} })

export function useAppTheme() {
  return useContext(ThemeContext)
}

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => getCookie('kw_app_theme') === 'dark')

  useLayoutEffect(() => {
    if (typeof document === 'undefined') return
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
  }, [dark])

  const toggleTheme = useCallback(() => {
    setDark(prev => {
      const next = !prev
      setCookie('kw_app_theme', next ? 'dark' : 'light')
      return next
    })
  }, [])

  const setDarkValue = useCallback((val) => {
    setDark(val)
    setCookie('kw_app_theme', val ? 'dark' : 'light')
  }, [])

  return (
    <ThemeContext.Provider value={{ dark, toggleTheme, setDark: setDarkValue }}>
      {children}
    </ThemeContext.Provider>
  )
}
